export default __webpack_public_path__ + "assets/8c4a6e685208b655.jpg";